"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./skillBar2.scss");
var SkillBar2 = /** @class */ (function (_super) {
    __extends(SkillBar2, _super);
    function SkillBar2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SkillBar2.prototype.render = function () {
        return (react_1.default.createElement("div", { className: 'standing-bar-container' },
            react_1.default.createElement("div", { className: 'standing-bar' },
                react_1.default.createElement("div", { className: 'skill skill-card', "data-aos": "zoom-out", title: 'i think im very good with this two ' },
                    react_1.default.createElement("span", { className: 'triangle' },
                        react_1.default.createElement("span", null, "Expert")),
                    react_1.default.createElement("div", { className: 'skill-container' },
                        react_1.default.createElement("span", null, "HTML/CSS"))),
                react_1.default.createElement("div", { className: 'skill skill-card', "data-aos": "zoom-out", title: 'comfortable, need challenge tho ;)' },
                    react_1.default.createElement("span", { className: 'triangle' },
                        react_1.default.createElement("span", null, "High")),
                    react_1.default.createElement("div", { className: 'skill-container' },
                        react_1.default.createElement("span", null, "Javascript"),
                        react_1.default.createElement("span", null, "React"))),
                react_1.default.createElement("div", { className: 'skill skill-card', "data-aos": "zoom-out", title: 'so far so good, trying to improve' },
                    react_1.default.createElement("span", { className: 'triangle' },
                        react_1.default.createElement("span", null, "Medium")),
                    react_1.default.createElement("div", { className: 'skill-container' },
                        react_1.default.createElement("span", null, "Illustration"),
                        react_1.default.createElement("span", null, "UX"))),
                react_1.default.createElement("div", { className: 'skill skill-card', "data-aos": "zoom-out", title: 'still working on it, i will get better soon!!' },
                    react_1.default.createElement("span", { className: 'triangle' },
                        react_1.default.createElement("span", null, "Low")),
                    react_1.default.createElement("div", { className: 'skill-container' },
                        react_1.default.createElement("span", null, "LogoDesign"))),
                react_1.default.createElement("div", { className: 'skill skill-card', "data-aos": "zoom-out" },
                    react_1.default.createElement("span", { className: 'triangle' },
                        react_1.default.createElement("span", null, "Beginner")),
                    react_1.default.createElement("div", { className: 'skill-container' },
                        react_1.default.createElement("span", null, "Duh!! :(")))),
            react_1.default.createElement("div", { className: 'point', "data-aos": "zoom-in" }),
            react_1.default.createElement("div", { className: 'point', "data-aos": "zoom-in" }),
            react_1.default.createElement("div", { className: 'point', "data-aos": "zoom-in" }),
            react_1.default.createElement("div", { className: 'point', "data-aos": "zoom-in" }),
            react_1.default.createElement("div", { className: 'point', "data-aos": "zoom-in" })));
    };
    return SkillBar2;
}(react_1.Component));
exports.SkillBar2 = SkillBar2;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Skills/components/SkillBar2/SkillBar2.tsx
// module id = 70
// module chunks = 0